import Vue from 'vue'
import VueI18n from 'vue-i18n'
import defaultMessages from './locales/fr.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || process.env.VUE_APP_I18N_DEFAULT,
  fallbackLocale: 'fr',
  messages: {
    fr: defaultMessages,
  },
});

const loadedMessages = {};

export async function loadLocale(lang) {
  if (loadedMessages[lang]) return loadedMessages[lang];
  const response = await fetch(`${process.env.VUE_APP_TRANSLATE_API_URL}/translation/sav_front/${lang}`);
  if (!response.ok) {
    throw new Error(`Unable to fetch locale ${lang}`);
  }
  const messages = await response.json();
  loadedMessages[lang] = messages;
  return messages;
}

export async function setLocale(lang) {
  try {
    i18n.setLocaleMessage(lang, lang === process.env.VUE_APP_I18N_DEFAULT
      ? defaultMessages
      : await loadLocale(lang)
    );
  } catch(err) {
    i18n.setLocaleMessage(lang, defaultMessages);
  }
  i18n.locale = lang;
}

export const availableLangs = [
  process.env.VUE_APP_I18N_DEFAULT, 
  'en'
];

export default i18n;
